module.exports = __webpack_public_path__ + "images/pflegegrad4.svg?83759de673d58f53a532655ac2b2f2da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pflegegrad4.svg
// module id = XkXK
// module chunks = 0